import React from "react";

const Featurecard = () => {
  return (
    <section
      aria-label="We Transform the School Experience"
      className="
        w-screen relative left-1/2 right-1/2 mx-[-50vw]
        bg-[#c5935a]
        px-6 md:px-12 lg:px-16
        pt-16 pb-16
        mb-[-48px] md:mb-[-60px] lg:mb-[-80px]
      "
    >
      <div className="max-w-6xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-2 min-h-[360px] lg:min-h-[460px] gap-10 md:gap-0">
          
          {/* LEFT TEXT */}
          <div className="flex flex-col justify-center text-white pr-0 md:pr-10 lg:pr-16">
            
            <h2 className="text-2xl lg:text-3xl font-bold leading-tight mb-6 text-cyan-600">
              Our <span className="text-black">Vision</span>
            </h2>
            <p className="text-sm md:text-lg text-gray-200 leading-relaxed mb-6">
              St. Thomas Vidyalayam was founded with the foremost aim of
              inculcating the values of discipline, character, sincerity,
              obedience and punctuality among the students, followed closely by
              giving highest quality education to children from all classes and
              sections of our society.
            </p>

            <h2 className="text-2xl lg:text-3xl font-bold leading-tight mb-6 text-cyan-600">
              Qualified <span className="text-black">Teaching Team</span>
            </h2>
            <p className="text-sm md:text-lg text-gray-200 leading-relaxed mb-6">
              The teaching faculty consists of experienced and dedicated team of
              trained Under Graduates, Post Graduates and specialists in various
              fields. They contribute immensely to the high Academic standards
              and achievements in a consistent manner over the years.
            </p>
          </div>

          {/* RIGHT IMAGE */}
          <div className="relative">
            <img
              src="https://res.cloudinary.com/ddvpczzng/image/upload/v1765527157/FeatureCard_jn727a.jpg"
              alt="School featured visual"
              loading="lazy"
              className="w-full h-full max-h-[420px] lg:max-h-none object-cover md:rounded-none rounded-md"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Featurecard;
